/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import CodingEditor from 'app/views/components/CodingEditor'
import Icon from 'app/views/components/Icon'

import 'ace-builds/webpack-resolver'
import 'ace-builds/src-noconflict/ext-language_tools'
import 'ace-builds/src-noconflict/theme-monokai'
import 'ace-builds/src-noconflict/mode-javascript'
import 'ace-builds/src-noconflict/mode-c_cpp'
import 'ace-builds/src-noconflict/mode-csharp'
import 'ace-builds/src-noconflict/mode-golang'
import 'ace-builds/src-noconflict/mode-java'
import 'ace-builds/src-noconflict/mode-php_laravel_blade'
import 'ace-builds/src-noconflict/mode-python'
import 'ace-builds/src-noconflict/mode-ruby'
import 'ace-builds/src-noconflict/mode-swift'
import 'ace-builds/src-noconflict/mode-html_ruby'
import 'ace-builds/src-noconflict/mode-jsx'
import 'ace-builds/src-noconflict/mode-tsx'
import 'ace-builds/src-noconflict/mode-razor'
import 'ace-builds/src-noconflict/mode-typescript'
import 'ace-builds/src-noconflict/mode-html'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/mode-xml'
import 'ace-builds/src-noconflict/mode-css'
import 'ace-builds/src-noconflict/mode-text'
import 'ace-builds/src-noconflict/mode-smarty'
import 'ace-builds/src-noconflict/mode-sh'
import 'ace-builds/src-noconflict/mode-markdown'
import 'ace-builds/src-noconflict/mode-scss'
import 'ace-builds/src-noconflict/mode-sass'


const propTypes = {
  code: PropTypes.string,
  hasTest: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object, // withRouter
  }).isRequired,
  onPatch: PropTypes.func.isRequired,
}
const defaultProps = {
  code: '\n',
}


class CodeReviewEditor extends React.Component {
  constructor(props) {
    super(props)

    const fontSize = window.innerWidth <= 1400 ? 12 : 13
    window.codeEditorLineHeight = fontSize === 12 ? 16 : 17
    this.state = {
      localCode: '',
      isFullScreen: false,
      fontSize,
      showTopHintButton: false,
      showBottomHintButton: false,
    }
    this.onFullScreen = this.onFullScreen.bind(this)
    this.handleChangeCode = this.handleChangeCode.bind(this)
    this.onDisableHintButtons = this.onDisableHintButtons.bind(this)
    if (this.props.onRef) {
      this.props.onRef(this.ace)
    }
  }


  componentDidUpdate(prevProps) {
    if ((prevProps.markers.length > 0 && this.props.markers.length === 0)
      || (prevProps.fileName !== this.props.fileName)) {
      this.onDisableHintButtons()
    }
  }


  onDisableHintButtons() {
    this.setState({
      showBottomHintButton: false,
      showTopHintButton: false,
    })
  }


  onFullScreen() {
    const { isFullScreen } = this.state
    this.height = '100%'
    this.setState({
      isFullScreen: !isFullScreen,
    })
  }

  onCheckMarkers() {

  }

  handleChangeCode(currentCode) {
    const { onUpdate } = this.props
    this.setState({ localCode: currentCode }, () => {
      if (onUpdate) {
        onUpdate(this.state.localCode)
      }
    })
  }


  render() {
    const { isFullScreen } = this.props
    return (
      <div
        style={isFullScreen ? {
          position: 'relative',
          width: '100%',
          height: 'calc(100vh - 80px)',
          left: 0,
          top: 0,
          zIndex: 1000,
        } : {}}
      >
        <div className="uk-inline" style={{ display: 'block' }}>
          <CodingEditor
            contentUUID={this.props.contentUUID}
            assessmentUUID={this.props.assessmentUUID}
            fileName={this.props.fileName}
            markers={this.props.markers}
            onScroll={(editor) => {
              if (this.props.markers.length > 0) {
                const height = document.getElementById('ace-editor-code-review').offsetHeight
                const top = editor.session.$scrollTop
                const startLine = parseInt((top / window.codeEditorLineHeight) + 1, 10)
                const endLine = parseInt(((height + top) / window.codeEditorLineHeight), 10)
                this.props.markers.forEach((marker) => {
                  if (marker.endRow < startLine) {
                    return this.setState({
                      showTopHintButton: true,
                    })
                  }
                  if (marker.endRow < endLine) {
                    return this.setState({
                      showTopHintButton: false,
                    })
                  }
                  if (marker.startRow > endLine && marker.startRow > startLine) {
                    return this.setState({
                      showBottomHintButton: true,
                    })
                  }
                  if (marker.startRow > startLine) {
                    return this.setState({
                      showBottomHintButton: false,
                    })
                  }
                })
              }
            }}
            ref={this.editor}
            showPrintMargin={false}
            height={isFullScreen ? `${(window.innerHeight - 120)}px` : 'calc(55vh - 40px)'}
            width="100%"
            placeholder=""
            id="ace-editor-code-review"
            onChange={this.handleChangeCode}
            fontSize={this.state.fontSize}
            showGutter
            wrapEnabled
            highlightActiveLine
            readOnly={this.props.readOnly}
            code={this.props.code}
            style={{ zIndex: 50 }}
          />
          {this.state.showTopHintButton && (
            <button
              className="uk-button-small uk-button uk-button-primary uk-position-top-center uk-margin-small-top uk-text-small"
              type="button"
              style={{ zIndex: 51, padding: '2px 10px', background: 'green', display: 'flex' }}
            >
              1+ Hint
              <Icon
                ratio={0.7}
                name="arrow-up"
              />
            </button>
          )}
          {this.state.showBottomHintButton && (
            <button
              className="uk-button-small uk-button uk-button-primary uk-position-bottom-center uk-margin-small-bottom uk-text-small"
              type="button"
              style={{ zIndex: 51, padding: '2px 10px', background: 'green', display: 'flex' }}
            >
              1+ Hint
              <Icon
                name="arrow-down"
                ratio={0.7}
              />
            </button>
          )}
          <Icon
            onClick={this.props.onFullScreen || this.onFullScreen}
            name={isFullScreen ? 'fullscreen-exit' : 'fullscreen'}
            style={{
              position: 'absolute',
              cursor: 'pointer',
              zIndex: 10003,
              top: 10,
              right: 20,
            }}
          />
        </div>
      </div>
    )
  }
}

CodeReviewEditor.propTypes = propTypes
CodeReviewEditor.defaultProps = defaultProps

export default withRouter(CodeReviewEditor)
